import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './public/pages/landing/landing.component';
import { BusinessServicesPageComponent } from './public/pages/landing/business-services/business-services-page/business-services-page.component';
import { authGuard } from './account/services/auth.guard';
import { maintenanceGuard } from './maintenance/maintenance.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [maintenanceGuard],
    children: [
      { path: '', component: BusinessServicesPageComponent },
      {
        path: 'marketplace',
        loadChildren: () =>
          import('./public/pages/landing/marketplace/marketplace.routes'),
      },
      {
        path: 'financial-products',
        loadChildren: () =>
          import('./public/pages/landing/financial-products/financial-products.routes'),
      },
      {
        path: 'data-marketplace',
        loadComponent: () =>
          import('./public/pages/landing/data-marketplace/data-marketplace.component').then(
            (c) => c.DataMarketplaceComponent
          ),
        data: {
          footerVisible: false, // скрываем футер, LandingComponent читает этот ключ
        },
      },
      {
        path: 'expat-centre',
        loadChildren: () =>
          import('./public/pages/landing/expat/expat-home.routes'),
      },
      {
        path: 'property',
        loadChildren: () =>
          import('./public/pages/landing/property/property.routes'),
      },
    ],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'approval',
    loadChildren: () =>
      import('./portal/modules/post-registration-application/post-registration-application.module').then((m) => m.PostRegistrationApplicationModule),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'portal',
    loadChildren: () =>
      import('./portal/portal.module').then((m) => m.PortalModule),
    canActivate: [maintenanceGuard, authGuard],
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
